export const LEAD_SOURCE_LEADOMATIC = '5be93e5f683059f77dbcef4c';

export const USER_GROUP_TRANSPORT = '5bb5cf6087ccbe393434b649';
export const USER_GROUP_ADMIN = '5b6a9ee2ba52006858939023';
export const USER_GROUP_SUPER = '5b6a9ee2ba52006858939024';
// Call Center Manager
export const USER_GROUP_CCM = '5bb1d5980495fed3883c07ac';

export const USER_STATUS_ACTIVE = '5bbb09fb60dc39407f5623aa';
export const SYSTEM_USER = '5b840260a363ea4bc4442aca';



// WEBPACK FOOTER //
// ./src/common/constants/index.js